'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elasticSearch = exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];
function formatUrl(path) {
  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  return encodeURI(_config2.default.apiV2Url + adjustedPath);
}

var ApiClientv2 = function () {
  function ApiClientv2(req) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ApiClientv2);

    methods.forEach(function (method) {
      return _this[method] = function (path) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref.params,
            data = _ref.data,
            jsonData = _ref.jsonData,
            attach = _ref.attach;

        return new _promise2.default(function (resolve, reject) {
          var request = _superagent2.default[method](formatUrl(path));
          if (__SERVER__ && req.get('cookie')) {
            request.set('cookie', req.get('cookie'));
          }
          if (params) {
            request.query(params);
          }
          if (attach) {
            attach.forEach(function (item) {
              return request.attach(item.key, item.value);
            });
          }
          if (jsonData) {
            request.set('content-type', 'application/json');
            request.send(jsonData);
          } else if (data) {
            // field.forEach(item => request.field(item.key, item.value));
            for (var fieldName in data) {
              if (data.hasOwnProperty(fieldName)) {
                request.field(fieldName, data[fieldName]);
              }
            }
          }
          request.end(function (err) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                body = _ref2.body;

            return err ? reject(body || err) : resolve(body);
          });
        });
      };
    });
  }

  (0, _createClass3.default)(ApiClientv2, [{
    key: 'empty',
    value: function empty() {}
  }]);
  return ApiClientv2;
}();

exports.default = ApiClientv2;
var elasticSearch = exports.elasticSearch = new ApiClientv2();


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClientv2.js
// module id = 726
// module chunks = 0